import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalDesignReadDto } from "../dto/solar-proposal-design.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Proposal design section read. It loads and fails apart from the
 * header read, so its errors stay inside the section; the header read owns the
 * page-level access states and the 401 sign-in redirect.
 */
export default function useSolarProposalDesign(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalDesignReadDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.design(proposalId ?? ``),
    queryFn: () => solarProposalService.getDesign(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
